import { render, staticRenderFns } from "./AdminActivityChart.vue?vue&type=template&id=772474c2&scoped=true&"
import script from "./AdminActivityChart.vue?vue&type=script&lang=js&"
export * from "./AdminActivityChart.vue?vue&type=script&lang=js&"
import style0 from "./AdminActivityChart.vue?vue&type=style&index=0&id=772474c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772474c2",
  null
  
)

export default component.exports